// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"e7b05ab3","352":"e14fd189","580":"3db9dc6e"}[chunkId] + ".chunk.css";
};